import React, { useEffect, useRef, useState } from "react";
import { useAuth } from "../../auth/FirebaseAuth.js";
import { useNavigate } from "react-router-dom";
import { getUserById } from "../../models/UserFunctions.js";
import { getOrgByRef, getUsersByOrgRef } from "../../models/OrgFunctions.js";
import ConfirmationSmsModal from "../../modals/ConfirmationSmsModal.js";
import Column from "../../layout/Column.js";
import Row from "../../layout/Row.js";

import { Switch, useTheme } from "@mui/material";

import { useAppContext } from "../../config/AppContext.js";
import { set } from "date-fns";
import { getOrRefreshFirebaseToken } from "../../config/getFirebaseToken.js";
import {
  getArrayDocDataByRef,
  getDateFromFlutter,
  getDateFromSeconds,
  getDocDataByRef,
  queryCollection,
} from "../../models/DataFunctions.js";
import { se } from "date-fns/locale";
import DropDownInline from "../../dropdowns/DropDownInline.js";
import BarChart1 from "../../charts/BarChart1.js";
import SmallSpinner from "../../loading/SmallSpinner.js";
import ListStatBlocks from "./ListStatBlocks.js";
import { useSnackbar } from "notistack";
import Tippy from "@tippyjs/react";
import { Spin } from "antd";
import Icon1 from "../../icons/Icon.js";
import { hasAudit, hasInfiltro } from "../../hexagone/VisibilityHelpers.js";
import { audit_steps_titles } from "../../folder_modals/TimelineFolderAudit.js";
import getTemporaryUrl from "../../api/getTemporaryUrl.js";
import JSZip from "jszip";
import { queryEvents, queryFolders } from "../../models/AlgoliaFunctions.js";
const MasterSmallStats = ({ navigateWorkspace, userData, orgData }) => {
  const theme = useTheme();
  const { currentUser, loading } = useAuth();

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const [loaded, setLoaded] = useState(false);
  const [dict_stats, setDict_stats] = useState({});
  // Function to fetch user and organization data
  const handleFetchData = async () => {
    try {
      let folders = [];
      let local_stats = { ...dict_stats };

      folders = await queryFolders(null, orgData, [
        {
          field: "master_id",
          operator: "==",
          value: orgData.id,
        },
      ]);
      local_stats.folders = folders.length;
      setDict_stats({
        ...local_stats,
      });
      let events = await queryEvents(null, orgData, [
        {
          field: "master_id",
          operator: "==",
          value: orgData.id,
        },
      ]);
      local_stats.events = events.length;
      setDict_stats({
        ...local_stats,
      });
      let filters_devis = [
        {
          field: "org_id",
          operator: "==",
          value: orgData.id,
        },
      ];
      let devis = await queryCollection("devis", filters_devis);
      local_stats.devis = devis.length;
      setDict_stats({
        ...local_stats,
      });
      let filters_controls = [
        {
          field: "org_id",
          operator: "==",
          value: orgData.id,
        },
      ];
      let controls = await queryCollection("control", filters_controls);
      local_stats.controls = controls.length;
      setDict_stats({
        ...local_stats,
      });
      handleFetchFoldersStatsDict(orgData, folders, controls, devis, events);
      setLoaded(true);
      // Set the fetched user and organization data in state
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const handleGoRDVFolder = () => {
    let new_folders_confis = appState.folders_config;
    new_folders_confis.only_folder_filter = "rdv";
    setAppState((prevState) => ({
      ...prevState,
      folders_config: new_folders_confis,
    }));

    navigateWorkspace("/folders");
  };
  const handleGoMAJFolder = () => {
    let new_folders_confis = appState.folders_config;
    new_folders_confis.only_folder_filter = "modif";
    setAppState((prevState) => ({
      ...prevState,
      folders_config: new_folders_confis,
    }));

    navigateWorkspace("/folders");
  };
  const handleGoXMLFolder = () => {
    let new_folders_confis = appState.folders_config;
    new_folders_confis.only_folder_filter = "xml";
    setAppState((prevState) => ({
      ...prevState,
      folders_config: new_folders_confis,
    }));

    navigateWorkspace("/folders");
  };
  const handleGoLateFolder = () => {
    let new_folders_confis = appState.folders_config;
    new_folders_confis.only_folder_filter = "late";
    setAppState((prevState) => ({
      ...prevState,
      folders_config: new_folders_confis,
    }));

    navigateWorkspace("/folders");
  };

  const handleGoAuditConfigFolder = (value) => {
    let new_folders_confis = appState.folders_config;
    new_folders_confis.audit_folder_filter = audit_steps_titles[value];
    setAppState((prevState) => ({
      ...prevState,
      folders_config: new_folders_confis,
    }));

    navigateWorkspace("/folders");
  };

  const handleFetchFoldersStatsDict = async (
    orgData,
    folders,
    controls,
    devis,
    events
  ) => {
    let finalised_folders = folders.filter(
      (folder) => folder.reglement_state === "done"
    );

    let realisee_finalised_folders = finalised_folders.filter(
      (folder) => folder.dateintervention?.seconds
    );

    let avg_finalisation_time = realisee_finalised_folders.reduce(
      (acc, folder) => {
        if (
          !folder.finalised_date?.seconds ||
          !folder.dateintervention?.seconds
        ) {
          return acc;
        }
        let diff =
          folder.finalised_date?.seconds -
          (folder.dateintervention?.seconds
            ? Math.max(
                folder.dateintervention?.seconds,
                folder.created_time?.seconds
              )
            : folder.created_time?.seconds);
        if (diff < 0) {
          return acc;
        }

        return acc + diff;
      },
      0
    );
    avg_finalisation_time =
      realisee_finalised_folders.length > 0
        ? avg_finalisation_time / realisee_finalised_folders.length
        : 0;
    let avg_finalisation_days = Math.floor(
      avg_finalisation_time / (60 * 60 * 24)
    );

    let avg_test_value = controls.reduce((acc, control) => {
      let mandatory_fields = control.cochamps.find(
        (champ) => champ.name === "Champs obligatoires"
      );
      if (!mandatory_fields) {
        return acc;
      }
      let test_champ = mandatory_fields.champs?.find(
        (champ) => champ.name === "Résultat test"
      );
      if (!test_champ) {
        return acc;
      }
      if (!test_champ.content) {
        return acc;
      }
      let test_value_string = test_champ.content[0];
      if (!test_value_string) {
        return acc;
      }

      let test_value = parseFloat(
        test_value_string.replace(" ", "").replace(",", ".").substring(0, 3)
      );

      if (isNaN(test_value) || test_value <= 0) {
        return acc;
      }
      return acc + test_value;
    }, 0);
    avg_test_value = avg_test_value / controls.length || 0;

    let perc_revisite =
      folders.length > 0
        ? (folders.filter((folder) => folder.revisions).length /
            folders.length) *
          100
        : 0;

    let revision_count = folders.filter((folder) => folder.revisions).length;

    let rdv_count = folders.filter(
      (folder) =>
        folder.dateintervention === null && folder.rdv_state === "wait"
    ).length;
    let draft_devis = devis.filter((devis) => devis.state === "draft").length;
    let done_devis_with_folder = devis.filter(
      (devis) => devis.state === "done" && devis.folder_ref
    ).length;
    let not_done_devis = devis.filter(
      (devis) => devis.state === "locked"
    ).length;
    let waiting_devis = devis.filter((devis) => devis.state === "wait").length;
    let done_no_folder_devis = devis.filter(
      (devis) => devis.state === "done" && !devis.folder_ref
    ).length;

    let notified_folders_count = folders.filter((folder) =>
      folder.notified_orgs_id?.includes(orgData.id)
    ).length;

    let late_folders_count = folders.filter(
      (folder) =>
        folder.late === true &&
        !(folder.revisions?.length === 0) &&
        folder.visions?.find((vision) => vision.org_id === orgData.id)
          ?.state === "current"
    ).length;

    let maj_requested_count = folders.filter(
      (folder) =>
        folder.modif_thermal?.activated === true &&
        !["wait", "done"].includes(folder.modif_thermal?.state) &&
        folder.visions?.find((vision) => vision.org_id === orgData.id)
          ?.state === "current"
    ).length;
    let xml_requested_count = folders.filter(
      (folder) =>
        folder.xml?.requested === true &&
        folder.xml?.state !== "done" &&
        folder.visions?.find((vision) => vision.org_id === orgData.id)
          ?.state === "current"
    ).length;

    let new_dict_stats = dict_stats;
    new_dict_stats["folders"] = folders.length;
    new_dict_stats["events"] = events.length;

    new_dict_stats["finalised_folders"] = finalised_folders.length;

    new_dict_stats["avg_finalisation_days"] = avg_finalisation_days;
    new_dict_stats["avg_test_value"] = avg_test_value;
    new_dict_stats["perc_revisite"] = perc_revisite;
    new_dict_stats["rdv_count"] = rdv_count;
    new_dict_stats["revision_count"] = revision_count;

    new_dict_stats["done_devis_with_folder"] = done_devis_with_folder;
    new_dict_stats["not_done_devis"] = not_done_devis;
    new_dict_stats["draft_devis"] = draft_devis;

    new_dict_stats["waiting_devis"] = waiting_devis;
    new_dict_stats["done_no_folder_devis"] = done_no_folder_devis;
    new_dict_stats["notified_folders_count"] = notified_folders_count;
    new_dict_stats["late_folders_count"] = late_folders_count;
    new_dict_stats["maj_requested_count"] = maj_requested_count;
    new_dict_stats["xml_requested_count"] = xml_requested_count;

    new_dict_stats["En prospection"] = folders.filter(
      (folder) => folder.timeline?.current_step === 0
    ).length;
    new_dict_stats["RDV Audit-MAR 1"] = folders.filter(
      (folder) => folder.timeline?.current_step === 1
    ).length;
    new_dict_stats["Audit restitué"] = folders.filter(
      (folder) => folder.timeline?.current_step === 2
    ).length;
    new_dict_stats["En contrôle conformité"] = folders.filter(
      (folder) => folder.timeline?.current_step === 3
    ).length;
    new_dict_stats["Déposé / en instruction"] = folders.filter(
      (folder) => folder.timeline?.current_step === 4
    ).length;
    new_dict_stats["Dossier octroyé"] = folders.filter(
      (folder) => folder.timeline?.current_step === 5
    ).length;
    new_dict_stats["Demande paiement"] = folders.filter(
      (folder) => folder.timeline?.current_step === 6
    ).length;
    new_dict_stats["Visite MAR 2"] = folders.filter(
      (folder) => folder.timeline?.current_step === 7
    ).length;
    new_dict_stats["Demande de solde"] = folders.filter(
      (folder) => folder.timeline?.current_step === 8
    ).length;
    new_dict_stats["Dossier clôturé"] = folders.filter(
      (folder) => folder.timeline?.current_step === 9
    ).length;

    setDict_stats(new_dict_stats);
  };

  useEffect(() => {
    if (orgData) {
      handleFetchData(); // Fetch user data when currentUser is available
    }
  }, [orgData]); // Re-run when currentUser changes

  // Display loading message while checking authentication or fetching user data
  // If the data is still loading, show skeletons
  // loading || !currentUser || !userData
  if (loading || !currentUser || !userData || !orgData) {
    return <></>;
  }

  return (
    <div className="flex flex-col w-fit h-fit  ">
      <div className="flex flex-wrap gap-2 max-w-c1p4k mt-4">
        <BlockNumer
          icon="folder"
          fill="black"
          title="Dossiers"
          onClick={() => navigateWorkspace("/folders")}
          number={dict_stats.folders}
          shadow_color="shadow-indigo-100"
        />{" "}
        <BlockNumer
          icon="planning"
          fill="black"
          title="Evénements"
          onClick={() => navigateWorkspace("/planning")}
          number={dict_stats.events}
          shadow_color="shadow-indigo-100"
        />{" "}
        <BlockNumer
          icon="message"
          title="Messages non lus"
          onClick={() => navigateWorkspace("/messages")}
          number={dict_stats.notified_folders_count}
          shadow_color="shadow-indigo-100"
        />
        <BlockNumer
          icon="devis"
          title="Devis brouillons"
          onClick={() => navigateWorkspace("/invoices")}
          number={dict_stats.draft_devis}
          shadow_color="shadow-indigo-100"
        ></BlockNumer>
        <BlockNumer
          icon="devis"
          title="Devis non envoyés"
          onClick={() => navigateWorkspace("/invoices")}
          number={dict_stats.not_done_devis}
          shadow_color="shadow-indigo-100"
        ></BlockNumer>
        <BlockNumer
          icon="devis"
          title="Devis en attente"
          onClick={() => navigateWorkspace("/invoices")}
          number={dict_stats.waiting_devis}
          shadow_color="shadow-indigo-100"
        ></BlockNumer>
        <BlockNumer
          icon="devis"
          title="Devis signés prêts"
          onClick={() => navigateWorkspace("/invoices")}
          number={dict_stats.done_no_folder_devis}
          shadow_color="shadow-indigo-100"
        ></BlockNumer>
        {hasInfiltro(orgData) && (
          <>
            <BlockNumer
              icon="date"
              onClick={handleGoRDVFolder}
              title="Demandes de RDV"
              number={dict_stats.rdv_count}
              shadow_color="shadow-indigo-100"
            />{" "}
            <BlockNumer
              icon="xml"
              onClick={handleGoXMLFolder}
              title="Demandes de XML"
              number={dict_stats.xml_requested_count}
              shadow_color="shadow-indigo-100"
            />{" "}
            <BlockNumer
              icon="restart"
              onClick={handleGoMAJFolder}
              title="Demandes de MAJ"
              number={dict_stats.maj_requested_count}
              shadow_color="shadow-indigo-100"
            />
            <BlockNumer
              icon="late"
              onClick={handleGoLateFolder}
              title="Dossiers en retard"
              number={dict_stats.late_folders_count}
              shadow_color="shadow-indigo-100"
            />
          </>
        )}
        {hasAudit(orgData) && (
          <>
            <BlockNumer
              icon="horloge"
              fill="black"
              title="En prospection"
              number={dict_stats["En prospection"] || 0}
              onClick={() => handleGoAuditConfigFolder(0)}
            />
            <BlockNumer
              icon="search"
              onClick={() => handleGoAuditConfigFolder(1)}
              title="RDV Audit-MAR 1"
              number={dict_stats["RDV Audit-MAR 1"] || 0}
            />
            <BlockNumer
              icon="horloge"
              onClick={() => handleGoAuditConfigFolder(2)}
              title="Audit restitué"
              number={dict_stats["Audit restitué"] || 0}
            />
            <BlockNumer
              icon="control"
              onClick={() => handleGoAuditConfigFolder(3)}
              title="En contrôle conformité"
              number={dict_stats["En contrôle conformité"] || 0}
            />
            <BlockNumer
              icon="folder"
              onClick={() => handleGoAuditConfigFolder(4)}
              title="Déposé/ en instruction"
              number={dict_stats["Déposé/ en instruction"] || 0}
            />
            <BlockNumer
              icon="folder"
              onClick={() => handleGoAuditConfigFolder(5)}
              title="Dossiers octroyés"
              number={dict_stats["Dossier octroyé"] || 0}
            />{" "}
            <BlockNumer
              icon="folder"
              onClick={() => handleGoAuditConfigFolder(6)}
              title="Demande paiement"
              number={dict_stats["Demande paiement"] || 0}
            />
            <BlockNumer
              icon="horloge"
              onClick={() => handleGoAuditConfigFolder(7)}
              title="Visite MAR 2"
              number={dict_stats["Visite MAR 2"] || 0}
            />
            <BlockNumer
              icon="horloge"
              onClick={() => handleGoAuditConfigFolder(8)}
              title="Demande de solde"
              number={dict_stats["Demande de solde"] || 0}
            />
            <BlockNumer
              icon="done2"
              onClick={() => handleGoAuditConfigFolder(9)}
              title="Dossiers clôturés"
              number={dict_stats["Dossier clôturé"] || 0}
            />
          </>
        )}
        <div className="bg-white rounded-xl cursor-pointer gap-2 pt-4 hover:shadow-lg hover:shadow-indigo-100 p-4 flex flex-col shadow-md shadow-indigo-100 w-c200   border-blue-100">
          <div className={`  text-black flex flex-row  h-4 gap-2 items-center`}>
            <div className=" w-c20   ">
              <Icon1 icon_name={"bridge"} size={18} fill={"black"}></Icon1>
            </div>
            <div className=" text-h3    ">Bridge</div>
            <div
              className={` ml-auto w-2 h-2 ${orgData.bridge?.connected ? "bg-green-300" : "bg-gray-300"} rounded-full ml-2`}
            ></div>
          </div>
          {hasInfiltro(orgData) && (
            <div
              className={`  text-black flex flex-row  h-4 gap-2 items-center`}
            >
              <div className=" w-c20   ">
                <Icon1 icon_name={"rtb"} size={20} fill={"black"}></Icon1>
              </div>

              <div className=" text-h3    ">RT Batiment</div>
              <div
                className={`ml-auto w-2 h-2 ${orgData.rtb_connected ? "bg-green-300" : "bg-gray-300"} rounded-full ml-2`}
              ></div>
            </div>
          )}
          <div className={`  text-black flex flex-row  h-4 gap-2 items-center`}>
            <div className=" w-c20   ">
              <Icon1 icon_name={"obbc"} size={18} fill={"black"}></Icon1>
            </div>
            <div className=" text-h3    ">OBBC</div>
            <div
              className={`ml-auto w-2 h-2 ${orgData.obbc?.connected ? "bg-green-300" : "bg-gray-300"} rounded-full ml-2`}
            ></div>
          </div>
          <div className={`  text-black flex flex-row  h-4 gap-2 items-center`}>
            <div className=" w-c20   ">
              <Icon1 icon_name={"pennylane"} size={18} fill={"black"}></Icon1>
            </div>
            <div className=" text-h3    ">Pennylane</div>
            <div
              className={`ml-auto w-2 h-2 ${orgData.pennylane?.connected ? "bg-green-300" : "bg-gray-300"} rounded-full ml-2`}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MasterSmallStats;

export const BlockNumer = ({
  title,
  number = null,
  icon = "folder",
  fill = "black",
  textclassname = "",
  sufix = "",
  onClick = () => {},
  shadow_color = "shadow-indigo-100",
}) => {
  return (
    <div
      onClick={onClick}
      className={`bg-white rounded-xl cursor-pointer  hover:shadow-lg  p-4 flex flex-col shadow-md ${shadow_color} hover:${shadow_color} w-c200   border-blue-100`}
    >
      <Icon1 icon_name={icon} size={20} fill={fill}></Icon1>{" "}
      <div
        className={` text-hx2 font-semibold text-black flex flex-row mt-4  ${textclassname}`}
      >
        {number !== null && !isNaN(number) ? number + sufix : <SmallSpinner />}
      </div>
      <div className=" text-h3 flex flex-row   ">{title}</div>
    </div>
  );
};
